export default {
  hubAnalyticsConfigurations: {
    RFV: [],
    DRE: [],
  },
  loadingReportsList: false,
  entitiesLinkedByHubConfiguration: null,
  hubAnalyticsLimits: {
    rfv: {
      notRecurrent: {
        createdTotal: 0,
        limitTotal: 0,
      },
      recurrent: {
        limitTotal: 0,
        createdTotal: 0,
      },
    },
    dre: {
      notRecurrent: {
        createdTotal: 0,
        limitTotal: 0,
      },
      recurrent: {
        limitTotal: 0,
        createdTotal: 0,
      },
    },
  },
}
